module.exports = __webpack_public_path__ + "assets/img/002.8706d24d.png";